var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10339",
    "data-name": "Group 10339",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_270",
    "data-name": "Ellipse 270",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#dc492b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bx-box",
    transform: "translate(45.223 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M12.629,3H3.181A1.181,1.181,0,0,0,2,4.181V5.362a1.181,1.181,0,0,0,.59,1.016v6.07a1.181,1.181,0,0,0,1.181,1.181h8.267a1.181,1.181,0,0,0,1.181-1.181V6.378a1.181,1.181,0,0,0,.59-1.016V4.181A1.181,1.181,0,0,0,12.629,3ZM3.181,4.181h9.448V5.362H3.181Zm.59,8.267v-5.9h8.267v5.9Z",
    transform: "translate(8.873 5.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M41.647-509.48c-1.687,1.393-3.124,2.616-3.183,2.719a.617.617,0,0,0-.059.376,27.161,27.161,0,0,0,3.146,2.719c1.7,1.393,3.183,2.564,3.279,2.6.339.133.368.015.405-1.695.044-2.012-.007-1.931,1.157-1.614a13.638,13.638,0,0,1,8.644,7.074,12.521,12.521,0,0,1,1.142,3.169,13.615,13.615,0,0,1-.1,6.286A13.734,13.734,0,0,1,46.134-478a11.7,11.7,0,0,1-3.257.376A11.7,11.7,0,0,1,39.62-478a13.7,13.7,0,0,1-9.963-9.963,15.034,15.034,0,0,1-.405-2.815c-.081-1.223-.273-1.6-.965-1.96a2.118,2.118,0,0,0-1.4-.015,1.877,1.877,0,0,0-.84.818,11.591,11.591,0,0,0,.251,4.392,17.033,17.033,0,0,0,6.89,10.265,16.533,16.533,0,0,0,9.69,3.006,16.533,16.533,0,0,0,9.69-3.006,17.206,17.206,0,0,0,6.6-9.137,17.658,17.658,0,0,0,.184-8.894,17.086,17.086,0,0,0-10.066-11.628A18.2,18.2,0,0,0,46.5-507.8c-1.3-.287-1.253-.214-1.26-2.225a12.5,12.5,0,0,0-.074-1.783.249.249,0,0,0-.251-.192A27.356,27.356,0,0,0,41.647-509.48Z",
    transform: "translate(420.406 296.203) rotate(-60)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnOrder);
export default __webpack_public_path__ + "static/media/Return Order.e79770c5addcc31cd724b6f730dd2c34.svg";
export { ForwardRef as ReactComponent };